<template>
  <layout-content>
    <template #toolbar>
      <el-select v-model="value" size="small" style="width:80px;" @change="dataTypeChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <el-select v-model="sortValue" size="small" style="width:135px;" @change="choiceChange">
        <el-option
          v-for="item in dataSort"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <data-time-query :query="query" />

      <site-query
        :sites="filterSites"
        :query="query"
      />

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-search"
        @click="getData"
      >查询</el-button>
    </template>

    <!--<template #filter>
      <section class="chart-option-wrapper">
        <p style="font-size: 13px; margin 0;">
          浓度单位：微克/立方米（CO毫克/立方米)
          <span style="color: #e04343;">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            2018年9月起，国控点实况标况并行，2018年9月以前数据，国控点日均实况数据以国家下发日均实况数据为准，小时数据仍未原标况，无实况数据;2018年12月中旬起，市控点实况标况并行，发布用实况，2018年底以前评估用标况。2019年1月1日起，实况标况并行，发布和评估用实况，标况用作参考。2021年6月应总站要求重新计算2015年至2018年市空点和区的实况数据，采用各个区标准站气象数据按照区内站点对应（中心城区徐家汇站点）方式对历史数据进行统一的换算，改方案有监测中心大气室和信息室讨论后制定。
          </span>
        </p>
      </section>
    </template>-->

    <template #body>
      <data-wrapper>
        <template #header>
          <span style="font-size:1em;color:#606266" v-if="sortValue === 3">对比年份:</span>
          <el-select
            v-model="query.years"
            v-if="sortValue === 3"
            size="small"
            multiple
            collapse-tags
            placeholder="请选择"
            style="width: 140px;"
          >
            <el-option
              v-for="item in earliest"
              :disabled="Number(item.value) >= Number(new Date(query.beginTime).format('YYYY'))"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" />

          <el-button
            :disabled="canNotSearch"
            type="success"
            size="small"
            icon="el-icon-download"
            @click="onDownloadBtnClick"
          >导出</el-button>
        </template>

        <div style="width: 100%; height: 500px;">
          <div style="width: 100%;display: flex;justify-content: center;margin-top: 20px;">
            <el-radio-group v-model="radioValue" size="small" v-if="sortValue !== 2" @change="getData()">
              <el-radio-button label="1001">SO2</el-radio-button>
              <el-radio-button label="1003">NO2</el-radio-button>
              <el-radio-button label="1005">CO</el-radio-button>
              <el-radio-button label="1006">O3</el-radio-button>
              <el-radio-button label="1007">PM10</el-radio-button>
              <el-radio-button label="1008">PM2.5</el-radio-button>
              <el-radio-button label="aqi">AQI</el-radio-button>
            </el-radio-group>
          </div>

          <a-q-i-data-compare-chart
            v-if="sortValue === 1 && compareData"
            ref="aqiDataCompareChart"
            :data="compareData"
          />

          <section class="site-chart-body" v-if="sortValue !== 1 && compareData.length !== 0">
            <section
              v-for="(data, index) in compareData"
              :key="index"
              class="chart-item"
            >
              <section class="chart-item-header">
                <span>{{data.name}}</span>
              </section>
              <section class="chart-item-body">
                <a-q-i-data-compares-chart
                  v-if="sortValue === 2"
                  ref="aqiDataComparesCharts"
                  :data="data.chartData"
                />
                <a-q-i-data-compare-chart
                  v-if="sortValue === 3"
                  ref="aqiDataComparesCharts"
                  :data="data.chartData"
                />
              </section>
            </section>
          </section>
        </div>
      </data-wrapper>
    </template>
  </layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import LayoutContent from '../../../../components/Layout/Content'
import DataTable from '../../../../components/Data/DataTable'
import CSVDownloader from '../../../../utils/CSVDownloader'
import AQIDataCompareChart from '../../../../components/Data/AQIDataCompareChart'
import AQIDataComparesChart from '../../../../components/Data/AQIDataComparesChart'
export default {
  name: 'DataManagementAQIDataCompareReport',
  routeInfo: {
    label: 'AQI数据对比',
    icon: 'fa fa-users'
  },
  extends: BaseFactorData,
  components: {LayoutContent, DataTable, AQIDataCompareChart, AQIDataComparesChart},
  data () {
    return {
      options: [{
        value: 1,
        label: '小时'
      }, {
        value: 24,
        label: '日'
      }],
      value: 1,
      dataSort: [{
        value: 1,
        label: '多站单因子'
      }, {
        value: 2,
        label: '单站多因子'
      }, {
        value: 3,
        label: '单站历史同比'
      }],
      sortValue: 1,
      radioValue: '1001',
      query: {
        granularity: 1,
        isAuditCompleted: false, // finished
        isSiteMerge: false,
        isTimeMerge: false,
        years: []
      },
      tableDataMap: {
        dataTime: '--',
        aqi: '--',
        grade: '--',
        primaryPollutant: '--',
        SO2iaqi: '--',
        SO2value: '--',
        NO2iaqi: '--',
        NOXvalue: '--',
        COiaqi: '--',
        COvalue: '--',
        O3iaqi: '--',
        O3value: '--',
        PM10iaqi: '--',
        PM10value: '--',
        'PM2.5iaqi': '--',
        'PM2.5value': '--',
        SO2id: '1001',
        SO2name: 'SO2',
        NO2id: '1003',
        NO2name: 'NO2',
        COid: '1005',
        COname: 'CO',
        O3id: '1006',
        O3name: 'O3',
        PM10id: '1007',
        PM10name: 'PM10',
        'PM2.5id': '1008',
        'PM2.5name': 'PM2.5'
      },
      chartFactorMap: {
        1001: {
          id: '1001',
          name: 'SO2',
          unit: 'μg/m3'
        },
        1003: {
          id: '1003',
          name: 'NO2',
          unit: 'μg/m3'
        },
        1005: {
          id: '1005',
          name: 'CO',
          unit: 'mg/m3'
        },
        1006: {
          id: '1006',
          name: 'O3',
          unit: 'μg/m3'
        },
        1007: {
          id: '1007',
          name: 'PM10',
          unit: 'μg/m3'
        },
        1008: {
          id: '1008',
          name: 'PM2.5',
          unit: 'μg/m3'
        },
        'aqi': {
          id: 'aqi',
          name: 'AQI',
          unit: ''
        }
      },
      factorIds: [
        1001,
        1003,
        1005,
        1006,
        1007,
        1008,
        'aqi'
      ],
      cacheDataList: [],
      dataList: [],
      compareData: {},
      csvData: []
    }
  },
  computed: {
    deviceCategories: () => [
      [process.env.SO2_DEVICE_CATEGORY, process.env.CO_DEVICE_CATEGORY, process.env.O3_DEVICE_CATEGORY, process.env.PM_DEVICE_CATEGORY, process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY],
      1
    ],
    earliest () {
      let result = []
      let start = process.env.Y_O_Y_YEAR
      for (let i = start; i <= Number(new Date().format('YYYY')); i++) {
        result.push({
          value: i,
          label: i
        })
      }
      return result.sort((a, b) => b.value - a.value)
    },
    formatFactorGroupMap () {
      return this.factorGroups.map(factorGroup => ({
        id: factorGroup.id,
        name: factorGroup.name,
        parentId: factorGroup.parentId
      })).reduce((map, factorGroup) => {
        map[factorGroup.id] = factorGroup
        return map
      }, {})
    },
    filterFactorMap () {
      let {factorMap} = this
      return this.filterSites.reduce((map, site) => site.devices.reduce((map, siteDevice) => siteDevice.siteDeviceFactors.reduce((map, siteDeviceFactor) => {
        let {factorId} = siteDeviceFactor

        if (!map[factorId]) {
          let factor = factorMap[factorId]
          map[factorId] = {
            id: factorId,
            name: factor.name,
            parentId: factor.parentId
          }
        }

        return map
      }, map), map), {})
    },
    filterFactors () {
      return Object.values(this.filterFactorMap)
    },
    factorTree () {
      let { filterFactors } = this
      let factorGroupMap = JSON.parse(
        JSON.stringify(this.formatFactorGroupMap)
      )
      let roots = []

      for (let i = 0; i < filterFactors.length; i++) {
        let factor = filterFactors[i]
        let { parentId } = factor
        let parent = factorGroupMap[parentId]

        if (parent && parentId !== 'm30000') {
          let { children } = parent

          if (!Array.isArray(children)) {
            children = parent.children = []
            filterFactors.splice(i + 1, 0, parent)
          }

          children.push(factor)
        } else {
          roots.push(factor)
        }
      }

      return roots
    }
  },
  methods: {
    dataTypeChange () {
      let {value} = this
      this.query.granularity = value
    },
    choiceChange () {
      if (this.sortValue === 3) {
        this.query.years = [new Date().format('YYYY') - 1]
      } if (this.sortValue !== 3) {
        this.query.years = []
      }
      let temp = {
        1: {},
        2: [],
        3: []
      }
      this.compareData = temp[this.sortValue]
      this.getData()
    },
    getData () {
      let {query, sortValue} = this
      let data = JSON.parse(JSON.stringify(query))
      if (sortValue === 3 && data.years.length === 0) {
        this.compareData = []
        this.renderData()
        this.$notify.error({
          title: '错误',
          message: '请选择对比年份',
          position: 'bottom-right'
        })
        return false
      }

      if (sortValue !== 3) {
        delete data.years
      }
      this.changeLoadStatus(true)
      if (query.siteIds.length === 0) {
        this.compareData = []
        this.renderData()
        this.changeLoadStatus(false)
        return false
      }

      this.$api.Aqi.getAQIData(data).then(backData => {
        if (!backData.length) {
          if (sortValue === 1) {
            this.compareData = {
              xAxisData: [],
              seriesData: []
            }
          } else {
            this.compareData = []
          }
          this.renderData()
          return
        }
        this.completeData(backData)
        this.formatData()
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    completeData (dataList) {
      let {query: {beginTime, granularity, siteIds}, sortValue, factorIds, filterSiteMap} = this
      let beginTS = new Date(beginTime).getTime()
      let endTS = new Date(dataList[dataList.length - 1].dataTime).getTime()
      let dataStep = granularity * 3600000
      let factorIdValueObj = factorIds.reduce((map, factorId) => {
        map[factorId] = null
        return map
      }, {})
      let siteIdDataMap

      if (sortValue !== 3) {
        siteIdDataMap = siteIds.reduce((map, siteId) => {
          let tsMap = map[siteId] = {}

          for (let ts = beginTS; ts <= endTS; ts += dataStep) {
            tsMap[ts] = {
              ts,
              dataTime: new Date(ts).format('YYYY-MM-DD HH:mm'),
              siteId: siteId,
              siteName: filterSiteMap[siteId].name,
              ...factorIdValueObj
            }
          }

          return map
        }, {})
      } else {
        let times = [...new Set(dataList.map(el => Number(new Date(el.dataTime).format('YYYY'))))]
        siteIdDataMap = siteIds.reduce((map, siteId) => {
          let tsMap = map[siteId] = {}

          times.forEach(el => {
            beginTS = new Date(el + '-' + new Date(beginTime).format('MM-DD 00:00:00')).getTime()
            endTS = new Date(el + '-' + new Date(dataList[dataList.length - 1].dataTime).format('MM-DD 00:00:00')).getTime()
            for (let ts = beginTS; ts <= endTS; ts += dataStep) {
              tsMap[ts] = {
                ts,
                dataTime: new Date(ts).format('YYYY-MM-DD HH:mm'),
                siteId: siteId,
                siteName: filterSiteMap[siteId].name,
                ...factorIdValueObj
              }
            }
          })

          return map
        }, {})
      }

      dataList.forEach(data => {
        let tsMap = siteIdDataMap[data.siteId]

        if (!tsMap) {
          return
        }

        let ts = new Date(data.dataTime).getTime()
        let tsData = tsMap[ts]

        if (!tsData) {
          return
        }

        let {pollutantData, aqi} = data
        const pollutantDataLen = pollutantData.length
        tsData.aqi = aqi
        for (let i = 0; i < pollutantDataLen; i++) {
          const data = pollutantData[i]
          let {rootFactorId} = data

          // if (!/^(PM2\.5|PM10)$/.test(rootFactorId)) {
          //   rootFactorId = rootFactorId.replace(/_24H$/, '')
          //   const {factorId} = data
          //   tsData[factorId] = data.iaqi
          //   tsData[factorId + 'name'] = rootFactorId
          // }
          const {factorId} = data
          tsData[factorId] = data.iaqi
          tsData[factorId + 'name'] = rootFactorId
        }
      })

      this.cacheDataList = Object.freeze(Object.values(siteIdDataMap).reduce((list, tsMap) => list.concat(Object.values(tsMap)), []))
    },
    formatData () {
      let {cacheDataList, chartFactorMap, sortValue, radioValue, query: {siteIds}, factorIds, filterSiteMap} = this

      switch (sortValue) {
        case 1:
          let data = {
            xAxisData: [...new Set(cacheDataList.map(el => el.dataTime))].sort((x, y) => new Date(x) - new Date(y)),
            legendData: cacheDataList.map(el => el.siteName),
            chartFactorData: chartFactorMap[radioValue],
            seriesData: Object.values(cacheDataList.reduce((map, item, i) => {
              if (!map[item.siteId]) {
                map[item.siteId] = {
                  name: item.siteName,
                  type: 'line',
                  showSymbol: false,
                  smooth: true,
                  data: []
                }
              }

              map[item.siteId].data.push(item[radioValue] ? item[radioValue].toFixed(1) : '--')

              return map
            }, {}))
          }

          this.compareData = data

          break
        case 2:
          let datalist = cacheDataList.reduce((map, item) => {
            if (!map[item.siteId]) {
              map[item.siteId] = {
                name: item.siteName,
                data: []
              }
            }

            map[item.siteId].data.push(item)
            return map
          }, {})
          let xAxisData2 = [...new Set(cacheDataList.map(el => el.dataTime))].sort((x, y) => new Date(x) - new Date(y))

          let arr = siteIds.map(item => {
            return {
              name: datalist[item].name,
              chartData: {
                xAxisData: xAxisData2,
                legendData: ['SO2', 'NO2', 'CO', 'O3', 'PM10', 'PM2.5', 'AQI'],
                seriesData: factorIds.map(el => {
                  if (el === 1005) {
                    return {
                      name: chartFactorMap[el].name,
                      yAxisIndex: 2,
                      type: 'line',
                      showSymbol: false,
                      data: datalist[item].data.map(element => element[el] ? element[el].toFixed(1) : '--')
                    }
                  }
                  return {
                    name: chartFactorMap[el].name,
                    yAxisIndex: chartFactorMap[el].name === 'AQI' ? 0 : 1,
                    type: 'line',
                    showSymbol: false,
                    data: datalist[item].data.map(element => element[el] ? element[el].toFixed(1) : '--')
                  }
                })
              }
            }
          })

          this.compareData = new Array(...arr)

          break
        case 3:
          if (cacheDataList.length === 0) {
            this.compareData = siteIds.map(item => {
              return {
                name: filterSiteMap[item].name,
                chartData: {
                  xAxisData: [],
                  chartFactorData: chartFactorMap[radioValue],
                  legendData: [],
                  seriesData: [{
                    type: 'line',
                    showSymbol: false,
                    data: []
                  }]
                }
              }
            })
            return false
          }
          let xAxisData3 = [...new Set(cacheDataList.map(el => el.dataTime))].sort((x, y) => new Date(x) - new Date(y))

          let siteDataList = cacheDataList.reduce((map, item) => {
            if (!map[item.siteId]) {
              map[item.siteId] = {
                name: item.siteName,
                data: []
              }
            }

            map[item.siteId].data.push(item)
            return map
          }, {})

          let contrast = siteIds.map(item => {
            let legendData = [...new Set(cacheDataList.map(el => Number(new Date(el.dataTime).format('YYYY'))))]
            return {
              name: siteDataList[item].name,
              chartData: {
                xAxisData: xAxisData3,
                chartFactorData: chartFactorMap[radioValue],
                legendData: [...new Set(cacheDataList.map(el => new Date(el.dataTime).format('YYYY')))],
                seriesData: legendData.map(el => {
                  return {
                    name: el,
                    type: 'line',
                    showSymbol: false,
                    data: siteDataList[item].data.filter(data => Number(new Date(data.dataTime).format('YYYY')) === el).map(element => element[radioValue] ? element[radioValue].toFixed(1) : '--')
                  }
                })
              }
            }
          })

          this.compareData = Object.values(contrast)

          break
      }
    },
    renderData () {
      this.$nextTick(() => {
        if (this.sortValue === 1) {
          this.$nextTick(() => {
            this.$refs['aqiDataCompareChart'].render()
          })
        } else {
          if (!this.$refs['aqiDataComparesCharts'] || !this.$refs['aqiDataComparesCharts'].length) return
          this.$refs['aqiDataComparesCharts'].forEach(chart => {
            this.$nextTick(() => {
              chart.render()
            })
          })
        }
      })
    },
    onDownloadBtnClick () {
      let {cacheDataList, query: {beginTime, endTime, siteIds}, sortValue, radioValue, filterSiteMap, chartFactorMap} = this
      let csvName = `${new Date(beginTime).format('YYYY年MM月DD日')}_${new Date(endTime).format('YYYY年MM月DD日')}AQI数据对比`
      let firstColumn, secondColumn, data, temp

      firstColumn = ['浓度单位：μg/m³(CO mg/m³)']
      temp = cacheDataList.reduce((map, item) => {
        if (!map[item.siteId]) {
          map[item.siteId] = {
            name: item.siteName,
            data: []
          }
        }

        map[item.siteId].data.push(item)
        return map
      }, {})

      switch (sortValue) {
        case 1:
          secondColumn = siteIds.map(item => filterSiteMap[item].name)

          secondColumn.unshift('因子')
          secondColumn.unshift('时间')

          data = Object.values(cacheDataList.reduce((map, item) => {
            if (!map[item.ts]) {
              map[item.ts] = {
                dataTime: item.dataTime,
                factor: chartFactorMap[radioValue].name,
                data: []
              }
            }

            map[item.ts].data.push(item[radioValue] ? Number(item[radioValue]).toFixed(1) : '--')

            return map
          }, {})).map(el => [el.dataTime, el.factor, ...el.data])

          CSVDownloader([firstColumn, secondColumn, ...data], csvName)
          break
        case 2:
          secondColumn = Object.values(chartFactorMap).map(item => item.name)

          secondColumn.unshift('站点')
          secondColumn.unshift('时间')

          data = Object.values(temp).map(item => {
            let backData = []

            item.data.forEach(el => {
              let factorData = Object.values(chartFactorMap).map(element => el[element.id] ? Number(el[element.id]).toFixed(1) : '--')
              backData.push([el.dataTime, item.name, ...factorData])
            })

            return backData
          }).reduce((a, b) => a.concat(b))

          CSVDownloader([firstColumn, secondColumn, ...data], csvName)

          break
        case 3:
          secondColumn = [...new Set(cacheDataList.map(el => new Date(el.dataTime).format('YYYY')))]

          secondColumn.unshift('因子')
          secondColumn.unshift('站点')
          secondColumn.unshift('时间')

          let groupData = []

          siteIds.forEach(item => {
            let arr = temp[item].data.reduce((map, el) => {
              let days = new Date(el.dataTime).format('MM-DD HH:mm:ss')

              if (!map[days]) {
                map[days] = {
                  dataTime: days,
                  site: temp[item].name,
                  factor: chartFactorMap[radioValue].name,
                  data: []
                }
              }

              map[days].data.push(el[radioValue] ? Number(el[radioValue]) : '--')

              return map
            }, {})

            groupData.push(Object.values(arr))
          })

          data = groupData.reduce((a, b) => a.concat(b)).map(el => [el.dataTime, el.site, el.factor, ...el.data])

          CSVDownloader([firstColumn, secondColumn, ...data], csvName)

          break
      }
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
.site-chart-body {
  width: 100%;
  height: 100%;
  padding-top: 10px;
}

.chart-item-header {
  width: 100%;
  line-height: 1.8em;
  padding: 0 10px;
  background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
  background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
  color: #ffffff;
  font-weight: 600;
}

.chart-item-body {
  height: 450px;
}
.el-date-editor {
  width: 165px;
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/02Normal/15AQI-Data-Compare/index.vue